import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import config from "@/config/index";
import "./utils/vant.js";
import md5 from "js-md5";

Vue.prototype.$md5 = md5;

// import VueVideoPlayer from "vue-video-player";
// import "vue-video-player/src/custom-theme.css";
// import "video.js/dist/video-js.css";

// Vue.use(VueVideoPlayer);

import "@/assets/CSS/h5_layout.less";
import "@/assets/CSS/style.less";
import "@/assets/CSS/style2.less";
/*引入资源请求插件*/
import VueResource from "vue-resource";
import WeiXin from "@/utils/weixin";

import VueAwesomeSwiper from "vue-awesome-swiper";

// import style (>= Swiper 6.x)
import "swiper/swiper-bundle.css";

// import style (<= Swiper 5.x)
// import "swiper/css/swiper.css";

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import { PullRefresh, List, ActionSheet } from "vant";

Vue.use(PullRefresh).use(List).use(ActionSheet).use(PullRefresh);

/*使用VueResource插件*/
Vue.use(VueResource);

// // // 控制台开启控制
// import VConsole from "vconsole";
// new VConsole();

// 设置rem以及相关配置
import remAndPhoneConfig from "./config/remConfig";
remAndPhoneConfig();
window.onresize = function() {
  remAndPhoneConfig();
};

// 设置高度，解决 scrollTop = 0 无效的问题
var _height = document.documentElement.clientHeight;

Vue.config.productionTip = false;

// var url = location.href.split("#")[0];
// WeiXin.shareUrl(url);

new Vue({
  data: {
    accountNo: "",
    channel: "", //来源
    openId: "",
    phone: "", //手机号
    loginFlag: false, //手机登录状态
    imgCodeBaseURL: config.imgCodeBaseURL,
    imgBaseURL: config.imgBaseURL,
    key: "" //点金页面url的加密串
  },
  router,
  render: h => h(App)
}).$mount("#app");
